import React from 'react';
import LegalPage from './LegalPage';

const ShippingPolicyPage = () => {
  return (
    <LegalPage title="Shipping Policy" slug="shipping-policy" lastUpdated="January 2026">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">1. Shipping Coverage</h2>
        <p className="text-zinc-700 leading-relaxed">
          We ship to all locations across India. Free shipping is provided on all orders, regardless of order value.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">2. Delivery Timeline</h2>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li><strong>Metro Cities:</strong> 2-3 business days (Express Delivery)</li>
          <li><strong>Tier 1 & 2 Cities:</strong> 3-5 business days</li>
          <li><strong>Other Locations:</strong> 5-7 business days</li>
          <li><strong>Remote Areas:</strong> 7-10 business days</li>
        </ul>
        <p className="text-zinc-700 leading-relaxed mt-3">
          Note: Delivery times are estimates and may vary due to weather, holidays, or other unforeseen circumstances.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">3. Order Processing</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          Orders are processed within 24 hours of confirmation (Monday-Saturday). Orders placed on Sunday will be processed the next business day.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">4. Tracking Your Order</h2>
        <p className="text-zinc-700 leading-relaxed">
          Once your order ships, you will receive a tracking number via email and SMS. You can track your order in real-time using our Track Order page or the courier partner's website.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">5. Shipping Partners</h2>
        <p className="text-zinc-700 leading-relaxed">
          We work with trusted courier partners including Blue Dart, DTDC, Delhivery, and India Post to ensure safe and timely delivery.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">6. Delivery Attempts</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          Our courier partners will attempt delivery 2-3 times:
        </p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>If you're unavailable, the courier will leave a note with contact information</li>
          <li>You can reschedule delivery or arrange pickup from the nearest courier center</li>
          <li>If delivery fails after all attempts, the order will be returned to us</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">7. Address Changes</h2>
        <p className="text-zinc-700 leading-relaxed">
          Address changes can be made within 2 hours of order placement by contacting customer support. Once the order is shipped, the address cannot be changed.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">8. Lost or Damaged Shipments</h2>
        <p className="text-zinc-700 leading-relaxed">
          If your package is lost or arrives damaged, please contact us immediately with photos (for damaged items). We will investigate and arrange a replacement or full refund.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">9. Contact for Shipping Queries</h2>
        <p className="text-zinc-700 leading-relaxed">
          For shipping-related questions:<br />
          Email: shipping@indicraft.in<br />
          Phone: +91 123-456-7890<br />
          Hours: Monday-Saturday, 9 AM - 7 PM IST
        </p>
      </section>
    </LegalPage>
  );
};

export default ShippingPolicyPage;
